import { 
  collection, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  serverTimestamp,
  query,
  where,
  getDocs
} from 'firebase/firestore';
import { db } from '../firebase/config';
import { sendEmailTemplate } from '../utils/emailUtils';
import { TripRole } from '../types/Trip';
import { RelationshipType } from '../types/Relationship';
import { getAuthHeaders } from '../utils/auth';
import axios from 'axios';

/**
 * Interface for Trip Invitation
 */
export interface TripInvitation {
   recipient_name?: string;
   tripId: string;
   tripTitle: string;
   inviterId: string;
   inviterName: string;
   recipient_email: string;
   role: TripRole;
   customMessage?: string;
   expiresAt?: Date;
   relationship?: {
      type: RelationshipType;
      label?: string | null;
      notes?: string | null;
   } | null;
   location?: string | null;
}

/**
 * Send a trip invitation to a user by email
 */
export const sendTripInvitation = async (invitation: TripInvitation): Promise<string> => {
   try {
      const headers = await getAuthHeaders();
      const response = await axios.post(
         `${process.env.REACT_APP_API_URL}/api/trip/invite`,
         {
            tripId: invitation.tripId,
            email: invitation.recipient_email,
            role: invitation.role,
            customMessage: invitation.customMessage || '',
            recipientName: invitation.recipient_name || '',
         },
         {
            headers,
         }
      );

      if (response.data.success) {
         return response.data.invitationId || 'invitation-sent';
      } else {
         throw new Error(response.data.error || 'Failed to send invitation');
      }
   } catch (error) {
      console.error('Error sending trip invitation:', error);
      if (axios.isAxiosError(error) && error.response?.data?.error) {
         throw new Error(error.response.data.error);
      }
      throw new Error('Failed to send invitation');
   }
}; 